// !!! THIS FILE IS GENERATED BY codegen.js !!!
import { css } from 'emotion';
export const xsmall = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 0px) {
      ${css(strings, ...args)}
    }
  `;
};
export const xsmallOnly = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 0px) and (max-width: 470px) {
      ${css(strings, ...args)}
    }
  `;
};
export const small = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 471px) {
      ${css(strings, ...args)}
    }
  `;
};
export const smallDown = (strings, ...args) => {
    return css `
    @media only screen and (max-width: 470px) {
      ${css(strings, ...args)}
    }
  `;
};
export const smallOnly = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 471px) and (max-width: 639px) {
      ${css(strings, ...args)}
    }
  `;
};
export const medium = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 640px) {
      ${css(strings, ...args)}
    }
  `;
};
export const mediumDown = (strings, ...args) => {
    return css `
    @media only screen and (max-width: 639px) {
      ${css(strings, ...args)}
    }
  `;
};
export const mediumOnly = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 640px) and (max-width: 1023px) {
      ${css(strings, ...args)}
    }
  `;
};
export const large = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 1024px) {
      ${css(strings, ...args)}
    }
  `;
};
export const largeDown = (strings, ...args) => {
    return css `
    @media only screen and (max-width: 1023px) {
      ${css(strings, ...args)}
    }
  `;
};
export const largeOnly = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 1024px) and (max-width: 1439px) {
      ${css(strings, ...args)}
    }
  `;
};
export const xlarge = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 1440px) {
      ${css(strings, ...args)}
    }
  `;
};
export const xlargeDown = (strings, ...args) => {
    return css `
    @media only screen and (max-width: 1439px) {
      ${css(strings, ...args)}
    }
  `;
};
export const xlargeOnly = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 1440px) and (max-width: 1919px) {
      ${css(strings, ...args)}
    }
  `;
};
export const xxlarge = (strings, ...args) => {
    return css `
    @media only screen and (min-width: 1920px) {
      ${css(strings, ...args)}
    }
  `;
};
export const maxWidth = "75em";



// WEBPACK FOOTER //
// ./src/theme/layout/breakpoints.ts